import { MenuScheduleSettingsBuilder } from "./schedule/menu.schedule.builder";
import { MenuDetailsSettingsBuilder } from "./details/menu.details.builder";
import { MenuPaymentSettingsBuilder } from "./payment/menu.payment.builder";
import { DocumentData } from "@angular/fire/firestore";
import { Menu } from "./menu.model";

export enum MenuBuilderState {
  CreatingMenu,
  LoadingMenu,
  EditingMenu,
  DeletingMenu
}
//Write only Version of Menu (use for adding and editing menu in venue)
export class MenuBuilder {
  private _isActive: boolean;
  private _startTime: number;
  private _endTime: number;
  private _schedule: MenuScheduleSettingsBuilder;
  private _details: MenuDetailsSettingsBuilder;
  private _payments: MenuPaymentSettingsBuilder;

  constructor(
    public readonly state: MenuBuilderState,
    public readonly timezone: string
  ) {
    this.default();
  }

  public get isActive(): boolean {
    return this._isActive;
  }

  public set isActive(b: boolean) {
    this._isActive = b;
  }

  public get schedule(): MenuScheduleSettingsBuilder {
    return this._schedule;
  }

  public get details(): MenuDetailsSettingsBuilder {
    return this._details;
  }

  public get payments(): MenuPaymentSettingsBuilder {
    return this._payments;
  }

  public default(): void {
    //DONE: Load Default isActive value;
    this._isActive = true;
    //DONE: Load Default values for Details
    this._details = new MenuDetailsSettingsBuilder();
    //TODO: Load Default values for Schedule
    this._schedule = new MenuScheduleSettingsBuilder(this.timezone);
    //TODO: Load Default values for Payment
    this._payments = new MenuPaymentSettingsBuilder();
  }

  public load(data: DocumentData): MenuBuilder {
    this._isActive = data.isActive;
    if (data.startTime != null) this._startTime = data.startTime;
    if (data.endTime != null) this._endTime = data.endTime;

    this._details.load(data.details);
    this._payments.load(data.payments);
    this._schedule.load(data.schedule);
    return this;
  }
  public edit(data: Menu): MenuBuilder {
    this._isActive = data.isActive;
    this._details.edit(data.details);
    this._payments.edit(data.payments);
    this._schedule.edit(data.schedule);
    return this;
  }
  public build = () => new Menu(this);

  public toJSON = () => ({
    isActive: this._isActive,
    details: this._details.toJSON(),
    payments: this._payments.toJSON(),
    schedule: this._schedule.toJSON()
  });
}
